var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('TextureStyleForm',{attrs:{"texture_style":_vm.texture_style,"readOnly":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }